module.exports = __webpack_public_path__ + "static/img/nf.69e6c425.svg";